import * as types from "../types";

const initialState = {
    loading: false,
    accessToken: null,
    bid_status_id: null,
    bid_status: null,
    updateBidStatusRes: null,
    error: null
} 

export default function submitUpdateBidStatusReducer(state = initialState, action){

    switch(action.type){
        case types.SUBMIT_UPDATE_BID_STATUS_REQUEST:
            return {
                ...state,
                loading: true,
                accessToken: action.payload.accessToken,
                bid_status_id: action.payload.bid_status_id,
                bid_status: action.payload.bid_status,
            }

        case types.SUBMIT_UPDATE_BID_STATUS_SUCCESS: 
            return {
                ...state,
                loading: false,
                updateBidStatusRes: action.payload.updateBidStatusRes
            }

        case types.SUBMIT_UPDATE_BID_STATUS_FAILURE: 
            return {
                ...state,
                loading: false,
                accessToken: null,
                bid_status_id: null,
                bid_status: null,
                updateBidStatusRes: null,
                error: action.payload.error
        }    

        case types.SUBMIT_UPDATE_BID_STATUS_RESET: 
        return {
            ...state,
            loading: false,
            accessToken: null,
            bid_status_id: null,
            bid_status: null,
            updateBidStatusRes: null,
            error: null
        }  


        default : 
            return state
    }

}